import { NextUI } from '@/components/NextUI';
import React from 'react';
import { useTranslations } from 'next-intl';

const EsignDeletionQuestion = ({
  hideModal,
  onCallback,
}: {
  hideModal: (data?: any) => void;
  onCallback: (key?: string, data?: any) => void;
}) => {
  const t = useTranslations('modals.esign_deletion');

  return (
    <NextUI.Modal
      className="max-w-[500px]"
      classNames={{ content: 'py-8 !px-4 md:!px-8' }}
      defaultOpen={true}
      name={'EsignDeletionQuestion'}
    >
      <h4>{t('title')}</h4>

      <p className="mt-5">{t('description')}</p>

      <div className="mt-5 flex gap-5 justify-end">
        <NextUI.Button
          className="!w-[130px]"
          variant="outline"
          onClick={hideModal}
        >
          {t('buttons.cancel')}
        </NextUI.Button>
        <NextUI.Button
          className="!w-[130px]"
          onClick={() => {
            onCallback();
            hideModal();
          }}
        >
          {t('buttons.delete')}
        </NextUI.Button>
      </div>
    </NextUI.Modal>
  );
};

export default EsignDeletionQuestion;
